import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-stamp-icon',
  templateUrl: './design-stamp.component.html'
})
export class DesignStampComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
